import React, {useState} from 'react'
import PageCreator from '../../components/PageCreator'
import reservationImage from '../../assets/images/events_background.jpg'
import {Form, Button, Col } from 'react-bootstrap'
import API from '../../utils/API'
import history from '../../components/History'
// import moment from 'moment'
import '../SubmitEvents/index.css'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default function SubmitEvents() {
const [eventTitle, setEventTitle] = useState('')
const [eventDescription, setEventDescription] = useState('')
const [eventDate, setEventDate] = useState('')
const [eventTime, setEventTime] = useState('')

const modules = { toolbar: [
    [{ 'header': [1, 2, false] }],
    ['bold', 'italic', 'underline','strike', 'blockquote', 'code-block', 'script'],
    [{'color': []}],
    [{'font': []}],
    [{'align': []}],
    [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
    ['link'],
    ['clean', 'formula', 'video']
    ],};

const submitEvent = event => {
        event.preventDefault();
  
    API.submitEvent({
        eventTitle: eventTitle,
        eventDescription: eventDescription,
        eventDate: eventDate,
        eventTime: eventTime
    }).then(
        history.push('/Events'),
    )
}
    return (
        <PageCreator imageName={reservationImage} opacityLevel='0.9'>
                 <p className='mainFont' style={{ fontSize: '1.5em' }}>Submit an Event</p>
                 <hr style={{backgroundColor: "#222222"}}/>

            
                <Form>
                    <Form.Row>
                    <Form.Group as={Col} controlId="eventTitle">
                        <Form.Label>Event Title</Form.Label>
                        <Form.Control
                          placeholder="Event Title"
                          value={eventTitle} 
                          onChange={event => setEventTitle(event.target.value)}
                        />
                    </Form.Group>

                    </Form.Row>
                  
                    <Form.Row style={{margin: '2px'}}>
                    <ReactQuill 
                        theme="snow"
                        className='ql-container' 
                        style={{backgroundColor:'#FFFFFF', width: '100vw'}}  
                        modules={modules} 
                        value={eventDescription} 
                        onChange={setEventDescription}
                    />
              
                
                    </Form.Row>
                    <Form.Row>    
                        <Form.Group as={Col} controlId="date">
                        <Form.Label>Date of Event</Form.Label>
                        <Form.Control 
                            type="date"
                            value={eventDate} 
                            onChange={event => setEventDate(event.target.value)}
                     
                        />
                     
                        </Form.Group>
                        <Form.Group as={Col} controlId="resTime">
                        <Form.Label>Time of Event</Form.Label>
                        <Form.Control 
                            as="select"
                            placeholder='eventTime' 
                            name='eventTime'
                            value={eventTime} 
                            onChange={event => setEventTime(event.target.value)}
                        >
                            <option value="" disabled>Select your option</option>
                            <option value='06:00:00'>6:00AM</option>
                            <option value='06:30:00'>6:30AM</option>
                            <option value='07:00:00'>7:00AM</option>
                            <option value='07:30:00'>7:30AM</option>
                            <option value='08:00:00'>8:00AM</option>
                            <option value='08:30:00'>8:30AM</option>
                            <option value='09:00:00'>9:00AM</option>
                            <option value='09:30:00'>9:30AM</option>
                            <option value='10:00:00'>10:00AM</option>
                            <option value='10:30:00'>10:30AM</option>
                            <option value='11:00:00'>11:00AM</option>
                            <option value='11:30:00'>11:30AM</option>
                            <option value='12:00:00'>12:00PM</option>
                            <option value='12:30:00'>12:30PM</option>
                            <option value='13:00:00'>1:00PM</option>
                            <option value='13:30:00'>1:30PM</option>
                            <option value='14:00:00'>2:00PM</option>
                            <option value='14:30:00'>2:30PM</option>
                            <option value='15:00:00'>3:00PM</option>
                            <option value='15:30:00'>3:30PM</option>
                            <option value='16:00:00'>4:00PM</option>
                            <option value='16:30:00'>4:30PM</option>
                            <option value='17:00:00'>5:00PM</option>
                            <option value='17:30:00'>5:30PM</option>
                            <option value='18:00:00'>6:00PM</option>
                            <option value='18:30:00'>6:30PM</option>
                            <option value='19:00:00'>7:00PM</option>
                            <option value='19:30:00'>7:30PM</option>
                            <option value='20:00:00'>8:00PM</option>
                            <option value='20:30:00'>8:30PM</option>
                            <option value='21:00:00'>9:00PM</option>
                            <option value='21:30:00'>9:30PM</option>
                            <option value='22:00:00'>10:00PM</option>
                            <option value='22:30:00'>10:30PM</option>
                            <option value='23:00:00'>11:00PM</option>
                            <option value='23:30:00'>11:30PM</option>
                        </Form.Control>
                        </Form.Group>
                    </Form.Row>

                    <Button style={{float: 'right'}} variant="outline-dark" onClick={submitEvent} type='submit'>Submit</Button>
            </Form>
 
        </PageCreator>
    )
    }
